import type { Ref } from 'vue'
import { computed } from 'vue'

/**
 * Event-date dots for the mini month grid from an external source (e.g. loaded appointments).
 */
export function useExternalEventIndicators(externalEventDates: Ref<Set<string>>) {
  const datesWithEvents = computed(() => externalEventDates.value)

  return { datesWithEvents }
}
